import * as React from 'react';
import { useEffect } from 'react';
import Button from 'components/Button';
import Container from 'components/Container';
import Row from 'components/Row';
import Text from 'components/Text';
import Image from 'components/Image';
import Columns2 from 'components/Columns2';
import Buttons from 'components/Buttons';
import Link from 'components/Link';
import SmilingWoman from 'assets/images/admin/AdminUpgrade/smiling-woman-on-phone.svg';
import EventTracking from 'lib/EventTracking';
import { baseTrackingPrefix } from 'constants/SelfServeConstants';

import '../styles/AdminUpgradePlanFlowEnd.scss';

type Props = {
  phoneNumber: string;
  requesterEmail: string;
  billingEmail?: string;
  purchaseSuccessful?: boolean;
  quoteUrl?: string;
};

const trackingPrefix = `${baseTrackingPrefix}.plan_flow_end`;

function track(key: string) {
  EventTracking.trackKey(`${trackingPrefix}.${key}`);
}

export default function AdminUpgradePlanFlowEnd(props: Props) {
  const { phoneNumber, billingEmail, requesterEmail, quoteUrl, purchaseSuccessful } = props;

  const displayEmail = billingEmail ?? requesterEmail;

  useEffect(() => track('view'), [])

  return (
    <div className="AdminUpgradePlanFlowEnd">
      <Container size="medium" align="center">
        <Row>
          <Text align="center">
            <Image src={SmilingWoman} width="400" height="180" />
          </Text>
        </Row>
        <Row>
          <Row size="small">
            <Text weight="semibold" size="xlarge" element="div">
              {purchaseSuccessful ? 'Thank you for your purchase!' : "We'll be in touch soon!"}
            </Text>
          </Row>
          <Row size="small">
            <Text align="left" color="thunder" size="large" element="div" weight="light">
              {purchaseSuccessful
                ? 'Paid features will be enabled for your organization as soon as we verify your role as an administrator. Keep an eye out for an email from our team in the next 3 business days.'
                : 'A member of our team will follow up soon to answer any questions and discuss how Remind can meet the needs of your organization.'}
            </Text>
          </Row>
        </Row>
        <Row size="small">
          {purchaseSuccessful ? (
            <Text align="left" color="thunder" size="medium" weight="light" lineHeight="xlarge">
              In the meantime, check out our{' '}
              <Link to={'/resources/admin-onboarding-guide/'} target="_blank">
                <Text weight="semibold">Administrator Onboarding Guide.</Text>
              </Link>
            </Text>
          ) : (
            <Text align="left" color="thunder" size="medium" weight="light" lineHeight="xlarge">
              How we'll contact you:
            </Text>
          )}
        </Row>
        {!purchaseSuccessful && (
          <Row>
            <Columns2>
              <Text lineHeight="medium" weight="semibold">
                Phone Number
              </Text>
              <Text lineHeight="medium" weight="semibold">
                Email
              </Text>
            </Columns2>
            <Columns2>
              <Text lineHeight="large" size="medium" weight="light">
                {phoneNumber}
              </Text>
              <Text lineHeight="large" size="medium" weight="light">
                {displayEmail}
              </Text>
            </Columns2>
          </Row>
        )}
        <Row>
          <Buttons>
            {quoteUrl ? (
              <Button to={quoteUrl}>Back To Quote</Button>
            ) : (
              <Button to={'/'}>Back To Remind</Button>
            )}
          </Buttons>
        </Row>
      </Container>
    </div>
  );
}
